import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// The Woodsy Craft Co. — Returning-customers (reorder) campaign (adc_gdmhsve53n).
// Real spend, conversions, and reorder ad sales from
// ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS. Its 14 conversions
// return ~9x on $343 of lifetime spend. Monthly series lives in realBrandData.ts.
// The budget is the platform's standing recommendation.
export const campWcReorder: FaireAdCampaignEntity = {
  token: "camp_wc_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_woodsy_craft",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 100,
  startedRunningAt: "2025-03-13",
  segmentMetrics: {
    numReorderConversions: 14,
    salesDollars: 3152,
    totalAdsSpendDollars: 343,
    returnOnAdSpend: 9.2,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
